var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlockedSign = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 19v2H5v-2h14Zm1-1v-8a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1v2l-.154-.004a3 3 0 0 1-2.842-2.842L2 18v-8a3 3 0 0 1 2.846-2.996L5 7h14l.154.004A3 3 0 0 1 22 10v8l-.004.154a3 3 0 0 1-2.842 2.842L19 21v-2a1 1 0 0 0 1-1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.346 2.567a1 1 0 0 1 1.308 0l5.113 4.427c.656.568.32 1.615-.488 1.743l-.167.013H6.888l-.167-.013c-.808-.128-1.144-1.175-.488-1.743l5.113-4.427ZM8.229 7.25h7.543L12 3.984 8.229 7.25ZM14.5 14a2.5 2.5 0 1 0-2.5 2.5V18a4 4 0 1 1 0-8 4 4 0 0 1 0 8v-1.5a2.5 2.5 0 0 0 2.5-2.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m14.5 11.5.53.53-4.998 5-1.062-1.06 5-5 .53.53Z"
})));
SvgBlockedSign.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlockedSign);
export default ForwardRef;